export interface ChatItem {
  id: number;
  question: string;
  answer: ChatAnswer;
}

export interface ChatAnswer {
  content: string;
  caseId?: number;
  caseLinkText?: string;
  draft?: CaseDraft;
  type: ChatAnswerType;
  hasValidationErrors?: boolean;
}

export enum ChatAnswerType {
  ok = 'OK',
  loading = 'LOADING',
  streaming = 'STREAMING',
  caseCreated = 'CASE_CREATED',
  unauthorized = 'UNAUTHORIZED',
  forbidden = 'FORBIDDEN',
  error = 'ERROR',
}

export interface CaseDraft {
  caseType: string;
  riskArea: string;
  dateTime: string;
  location: string;
  responsibleUnit: string;
  caseCategorisation: string;
  title: string;
  description: string;
}

export interface ChatFeedback {
  rating: 'positive' | 'negative' | 'none';
  selectedOption?: string;
  otherFeedback?: string;
}
